import React, { useState, useRef } from 'react';
import { useDispatch, useSelector } from "react-redux";
import { getFormValues } from "redux-form";
import { Modal, ErrorBanner, Button } from 'rhombus-react';
import { uploadVASTAudioCreative } from "reducers/creatives/VAST";
import { loadCreatives } from "reducers/Creatives";
import PreviewCard from './PreviewCard';

export function AudioPreview(props){
	const {
		commonModalProps,
		Breadcrumb,
		formName,
		versions,
		goBack,
	} = props;
	const { libraryId, closeModal } = commonModalProps;

	const settingsFormValues = useSelector(getFormValues(formName));
	const [selectedVersion, setSelectedVersion] = useState(null);
	const [isSaving, setIsSaving] = useState(false);
	const [errors, setErrors] = useState([]);
	const dispatch = useDispatch();
	const audiosContainerRef = useRef();

	const onSave = async () => {
		try {
			setIsSaving(true);
			const blob = await fetch(selectedVersion.audioUrl)
				.then((response) => {
					if (!response.ok) {
						throw new Error(`Response status ${response.status}`);
					}
					return response.blob();
				})
				.catch((error) => {
					console.error(`Fetch error: ${error.message}`);
					throw new Error(`Error downloading audio`);
				});
			const file = new File([blob], `${settingsFormValues.creativeName}.mp3`, { type: 'audio/mp3' });
			const createResponse = await dispatch(uploadVASTAudioCreative(libraryId, file, null, false, {
				success: '',
				error: '',
				onUploadProgress: undefined,
			}));
			if (!createResponse.success) {
				throw new Error(`Error creating audio creative`);
			}
			if (createResponse.payload?.data?.errors?.[0]?.errors?.length) {
				throw new Error(createResponse.payload.data.errors[0].errors[0].error);
			}
			dispatch(loadCreatives(libraryId));
			closeModal();
		} catch (e) {
			setErrors([e.message]);
		}
		setIsSaving(false);
	};

	function renderContent() {
		return (
			<>
				{Breadcrumb}
				<div ref={audiosContainerRef} className="c-modal-body">
					{!!errors.length && (
						<ErrorBanner messages={errors} />
					)}
					{(versions.length > 1) && (
						<span>Select your Audio</span>
					)}
					{versions.map((version, index) => (
						<PreviewCard
							/* eslint-disable-next-line react/no-array-index-key */
							key={index}
							index={index}
							libraryId={libraryId}
							version={version}
							isSelected={index === selectedVersion?.index}
							onSelect={(audioUrl) => {
								setSelectedVersion({ index, audioUrl });
							}}
							forceSelect={versions.length === 1}
							audiosContainerRef={audiosContainerRef}
						/>
					))}
				</div>
			</>
		);
	}

	function renderFooter() {
		return (
			<>
				<span>
					<Button theme="default" onClick={closeModal}>Cancel</Button>
					<Button className="back-to-settings" theme="blue" onClick={goBack}>Back to Settings</Button>
				</span>
				<Button
					theme="green"
					disabled={selectedVersion === null || isSaving}
					onClick={onSave}
					icon={isSaving ? 'fa-regular fa-circle-notch circle-spin' : null}
				>Save</Button>
			</>
		);
	}

	return <Modal {...commonModalProps} renderContent={renderContent} renderFooter={renderFooter} />;
}

export default AudioPreview;
